module.exports = __webpack_public_path__ + "static/media/gold_pkg_icon.c6c645bb.svg";